import React, { useState } from 'react';
import { Box, Paper, Stack, Tabs, Tab, Typography, Switch, FormControlLabel } from '@mui/material';
import { HiTemplate } from 'react-icons/hi';
import PropTypes from 'prop-types';
import Appbar from '../../components/Appbar';
import DrawerComponent from '../../components/Drawer';
import Body from '../../components/Body';
import Crowns from './Crowns';
import Badges from './Badges';
import { useDispatch, useSelector } from 'react-redux';
import { updateCrownPointsApi, resetUpdateCrownPoints } from '../../store/crowns-and-badges/updateCrownPoints';
import { getCrownsListApi } from '../../store/crowns-and-badges/getCrownsList';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`crowns-badges-tabpanel-${index}`}
            aria-labelledby={`crowns-badges-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `crowns-badges-tab-${index}`,
        'aria-controls': `crowns-badges-tabpanel-${index}`,
    };
}

export default function CrownsAndBadges() {
    const [value, setValue] = useState(0);
    const dispatch = useDispatch();
    const { result } = useSelector((state) => state.getCrownsList);
    const { loading: updateLoading } = useSelector((state) => state.updateCrownPoints);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleToggleChange = async (event) => {
        const isEnabled = event.target.checked;
        const payload = { is_enabled: isEnabled };
        try {
            await dispatch(updateCrownPointsApi(payload)).unwrap();
            dispatch(resetUpdateCrownPoints());
            dispatch(getCrownsListApi());
        } catch (err) {
            dispatch(resetUpdateCrownPoints());
        }
    };

    return (
        <>
            <Appbar />
            <DrawerComponent />
            <Body>
                <Stack direction="row" spacing={1} sx={{ my: 2, pl: '24px' }} alignItems="center" justifyContent="space-between">
                    <Stack direction="row" spacing={1} alignItems="center">
                        <HiTemplate size={30} />
                        <Typography>Crowns & Badges</Typography>
                    </Stack>

                    {value === 0 && (
                        <Box sx={{ pr: '24px' }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={result?.is_enabled || false}
                                        onChange={handleToggleChange}
                                        disabled={updateLoading}
                                        color="primary"
                                    />
                                }
                                label={`${result?.is_enabled ? "Disable" : "Enable"} crowns`}
                                labelPlacement="start"
                            />
                        </Box>
                    )}
                </Stack>

                <Paper elevation={0}>
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', pl: '24px' }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="crowns and badges tabs"
                            >
                                <Tab label="Crowns" {...a11yProps(0)} />
                                <Tab label="Badges" {...a11yProps(1)} />
                            </Tabs>
                        </Box>

                        <CustomTabPanel value={value} index={0}>
                            <Crowns />
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={1}>
                            <Badges />
                        </CustomTabPanel>
                    </Box>
                </Paper>
            </Body>
        </>
    );
}
